import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CouponsManagementTable from "../../components/CouponsManagement/CouponsManagementTable";
import CreateCoupons from "../../components/CouponsManagement/CreateCoupons";




const CreateCouponsPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Create Coupons"  subtitle={"Coupons Management"} subUrl={"coupons-management"}/>
       <CreateCoupons/>
      



            </MasterLayout>
        </>
    );
};

export default CreateCouponsPage;
